import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { FormDoc } from '../../../core/models/physician/form-doc';
import { FormFolder } from '../../../core/models/physician/form-folder';
import { FormService, FormServiceResolver } from '../../../core/services/v2/form.service';

@Component({
  selector: 'app-form-select-folders',
  templateUrl: './form-select-folders.component.html',
  styleUrls: ['./form-select-folders.component.scss']
})
export class FormSelectFoldersComponent implements OnInit {
  @Input() formDocument: FormDoc;
  @Output() toggleEvent = new EventEmitter();
  formFolders: FormFolder[];

  tempFormFolders: FormFolder[];
  showHideSelected = false;

  constructor(private _formServiceResolver: FormServiceResolver,
    private _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.getAllFormFolders();
  }

  resetFolderSelection() {
    this.showHideSelected = true;
    this.showSelected();
  }

  getAllFormFolders() {
    this._formServiceResolver.getFormService().subscribe(
      fvsc =>
        fvsc.getFormsGroups().subscribe(
          (list) => {
            this.formFolders = list.result;
            this.checkForSelectedFolders();
          },
          (error) => { console.error(error); }
        )
    );
  }

  checkForSelectedFolders() {
    this.formFolders.forEach((list, i) => {
      if (this.formDocument.formGroupIds)
        this.formDocument.formGroupIds.forEach(selected => {
          if (list.id === selected) {
            this.formFolders[i].checked = true;
          }
        });
    });
    this.tempFormFolders = this.formFolders;
  }

  changeList(selected, ind) {
    if (!this.formFolders[ind].checked) {
      this.formFolders[ind].checked = true;
    } else {
      this.formFolders[ind].checked = false;
    }
  }

  showSelected() {
    this.findFormFolder('');
    if (!this.showHideSelected) {
      this.formFolders = this.formFolders.filter(ele => ele.checked === true);
      this.showHideSelected = true;
    } else {
      this.formFolders = this.tempFormFolders;
      this.showHideSelected = false;
    }
  }

  findFormFolder(keyword: string) {
    keyword = keyword.trim();
    this.formFolders = this.tempFormFolders;
    if (keyword !== '') {
      this.formFolders = this.formFolders.filter(ele => (ele.name.toLowerCase()).match(keyword.toLowerCase()));
    }
  }

  saveFormFolders() {
    //console.log(this.tempInsurances.filter(ele => ele.checked === true));
    var self = this;
    const ids = self.tempFormFolders.filter(ele => ele.checked === true).map(a => a.id);

    console.log('foldersTosave', ids);
    self._formServiceResolver.getFormService().subscribe(fsvc =>

      fsvc.updateRelatedFormFolders(self.formDocument.id, ids).subscribe(
        (res) => {
          if (res.resultStatus.isSuccess) {
            if (res.result) {
              self.formDocument.formGroupIds = ids;
              self._snackBar.open("Folder selection was successfully updated", "Ok", {
                duration: 5000
              });

              self.toggleEvent.emit(self.formDocument);
            } else {
              console.error('Folder selection was not updated');
              self._snackBar.open('Folder selection was not updated', "Ok");
            }
          } else {
            console.error(res);
            self._snackBar.open(`Folder selection was not updated: ${res.resultStatus.message}`, "Ok");
          }
        },
        (error) => {
          console.error(error);
          self._snackBar.open(`Folder selection could not be updated${(error.error && error.error.resultStatus ? ': ' + error.error.resultStatus.message : '')}`, "Ok", {
            duration: 5000
          });
        }
      )
    );
  }
}
